import "./App.css";
import Banner from "./components/Banner";
import Portfolio from "./components/Portfolio";
// import Logo from "./assets/logo3.jpg";
import About from "./components/About";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Snowfall from "react-snowfall";

function App() {
    return (
        <div className="App">
            <Snowfall // Changes the snowflake color
                color="#795548"
                // Applied to the canvas element
                style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                }}
                // Controls the number of snowflakes that are created (default 150)
                snowflakeCount={40}
            />
            <div id="spinner" style={{ display: "none" }}>
                <div id="first_circle">
                    <div id="second_circle">
                        <div id="third_circle">
                            <div id="fourth_circle"></div>
                        </div>
                    </div>
                </div>
                <div id="welcome_div">
                    <p id="welcome_text" style={{ fontSize: 14 }}></p>
                </div>
            </div>
            <div className="body" style={{ display: "none" }}>
                <a href="#">
                    <div className="scroll-to-top" />
                </a>

                <nav className="navbar navbar-expand-sm nav">
                    {/* <!-- Brand --> */}
                    <div className=" container">
                        <a className="navbar-brand" href="#">
                            <span id="cool">
                                Co<span style={{ marginLeft: 0 }}>o</span>l
                            </span>
                            <span id="headed">
                                H<span style={{ marginLeft: -5 }}>e</span>aded
                            </span>
                        </a>

                        {/* <!-- Toggler/collapsibe Button --> */}
                        <div
                            className="navbar-toggler hanburger_menu"
                            id="hanburger_menu"
                        ></div>
                        {/* <!-- Navbar links --> */}

                        <div
                            className="collapse navbar-collapse"
                            id="collapsibleNavbar"
                        >
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <a href="#" className="nav-link">
                                        Home
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#about" className="nav-link">
                                        About
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#skills" className="nav-link">
                                        skills
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#portfolio" className="nav-link">
                                        portfolio
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#contact" className="nav-link">
                                        contact
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                {/* mobile */}

                <div className="mobile_nav" id="mobile_nav">
                    <nav className="navbar navbar__content">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a href="#" className="nav-link">
                                    Home
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#about" className="nav-link">
                                    About
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#skills" className="nav-link">
                                    skills
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#portfolio" className="nav-link">
                                    portfolio
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#contact" className="nav-link">
                                    contact
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* banner */}
                <Banner />
                {/* portfolio */}
                <div id="portfolio">
                    <Portfolio />
                </div>
                <div className="container my-5">
                    <div className="mini_box">
                        <p>
                            The works listed above was achieved with my skills.
                            Do you think yours cannot be achieved also? Kindly
                            contact me below.
                        </p>
                    </div>
                </div>
                {/* about */}
                <div id="about">
                    <About id="about" />
                </div>
                <div id="skills">
                    <Skills />
                </div>
                <div className="container my-5">
                    <div className="mini_box2">
                        <p>
                            Now tell me, do you think I cannot develop your
                            website or web App or give you an online presence?
                            That is why you need to contact me below.
                        </p>
                    </div>
                </div>
                <div id="contact">
                    <Contact />
                </div>
                <footer>
                    <div>
                        <div class="container">
                            <a href="https://facebook.com/josephonahsam">
                                <i class="fa fa-facebook" id="fafa2"></i>
                            </a>
                            &nbsp;&nbsp;
                            <a href="https://twitter.com/josephonahsam">
                                <i class="fa fa-twitter" id="fafa2"></i>
                            </a>
                            &nbsp;&nbsp;
                            <a href="https://github.com/coolheaded1">
                                <i class="fa fa-github" id="fafa2"></i>
                            </a>
                            &nbsp;&nbsp;
                            <a href="https://wa.me/+2349030306779">
                                <i class="fa fa-whatsapp" id="fafa2"></i>
                            </a>
                            &nbsp;&nbsp;
                            <br />
                            <br />
                            <p>Your satisfaction is my pleasure.</p>
                            <p>
                                &copy; {new Date().getFullYear()}. All Rights
                                Reserved
                            </p>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
}

export default App;
